(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  (function(){
    var form=document.getElementById('sofx-product-form');
    if(form){
      var sel=form.querySelector('[data-variant-select]'),btn=form.querySelector('[data-add]'),price=document.querySelector('[data-price]');
      if(sel){sel.addEventListener('change',function(){var o=sel.options[sel.selectedIndex];if(price)price.textContent=o.getAttribute('data-price');var ok=o.getAttribute('data-available')==='true';btn.disabled=!ok;btn.textContent=ok?btn.getAttribute('data-add-label')||btn.textContent:btn.getAttribute('data-sold-label')||btn.textContent;});}
    }
    var stage=document.querySelector('.sofx-pdp__stage img');
    document.querySelectorAll('[data-stage]').forEach(function(t){t.addEventListener('click',function(e){e.preventDefault();if(stage){stage.src=t.getAttribute('href');stage.removeAttribute('srcset');}document.querySelectorAll('[data-stage]').forEach(function(x){x.classList.remove('is-on')});t.classList.add('is-on');});});
  })();

  } catch(e) { console.error(e); }
})();
})();
